import React, { useState } from 'react';
import './FormPage.css';
import AIPopup from './AIPopup';
import SubmitPopup from './SubmitPopup';
// import { useHistory } from 'react-router-dom'; // Import useHistory from React Router
//

function FormPage() {

  const [isPopupVisible, setPopupVisible] = useState(false);

  const handleSubmit = () => {
    // Handle form submission logic (e.g., data validation, API request, etc.)

    // Set isPopupVisible to true to display the popup
    setPopupVisible(true);
  };

  const closePopupSubmit = () => {
    // Close the popup by setting isPopupVisible to false
    setPopupVisible(false);
  };


  // Define the available crop options
  const cropOptions = ['Wheat', 'Rice', 'Maize', 'Banana', 'Sugarcane', 'Potato'];

  // Initialize the formData state with default values
  const [formData, setFormData] = useState({
    crop: '', // Default value for crop
    area: '', // Default value for area
    month: '', // Default value for month
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleAIButtonClick = () => {
  //   console.log("AI Button");
  // };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
    
  //   // Create an object with form data
  //   const dataToSubmit = {
  //     crop: formData.crop,
  //     area: parseFloat(formData.area), // Convert to a number
  //     month: formData.month,
  //   };

  //   // Send a POST request to the server
  //   fetch('/submit-crop', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(dataToSubmit),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data.message);
  //       // Add code to handle the response as needed
  //     })
  //     .catch((error) => {
  //       console.error('Error:', error);
  //       // Handle the error
  //     });
  // };


  const [isPopupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };






  // const history = useHistory(); // Get the history object from React Router

  // const handleSubmit = () => {
  //   // Handle form submission logic (e.g., data validation, API request, etc.)

  //   // Once the form is successfully submitted, navigate to the "Last Page"
  //   history.push('/last-page');
  // };


  return (
    <div className="form-page">
      <h2 style={{justifyContent:"center", display:"flex", fontSize:"50px"}}>Planting Form</h2>
      {/* <form className='styled-form' action="http://localhost:5000/submit-crop" method="post" onSubmit={handleSubmit}> */}
      {/* <form className='styled-form' onSubmit={handleSubmit}> */}
      <form className='styled-form'>
        <div className="form-group">
          <label htmlFor="cropSelect">Which crop do you want to plant?</label>
          <select id="cropSelect" name="crop" value={formData.crop} onChange={handleInputChange}>
            <option value="">Select a crop</option>
            {cropOptions.map((crop, index) => (
              <option key={index} value={crop}>
                {crop}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="areaInput">Area of land (in acres):</label>
          <input
            type="number"
            id="areaInput"
            name="area"
            value={formData.area}
            onChange={handleInputChange}
            pattern="[0-9]*" // Use the pattern attribute to restrict input to numbers
          />
        </div>

        <div className="form-group">
          <label htmlFor="adharNo">Adhar Number:</label>
          <input
            type="number"
            id="adharNo"
            name="adhar"
            value={formData.adhar}
            // onChange={handleInputAdharChange} // not defined yet
            pattern="[0-9]*" // Use the pattern attribute to restrict input to numbers
          />
        </div>

        <div className="form-group">
          <label htmlFor="monthSelect">Month of plantation:</label>
          <label htmlFor="monthSelect" style={{color: 'blue'}}>Please select the month suitable for your selected crop!!</label>
          <select id="monthSelect" name="month" value={formData.month} onChange={handleInputChange}>
            <option value="">Select a month</option>
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
            {/* Add more months as needed */}
          </select>
        </div>

        <button type="button" className="ai-predict-button" id='ai-predict-button' onClick={openPopup}>
          AI Predict rate
        </button>
        <AIPopup isOpen={isPopupOpen} onClose={closePopup} />

        {/* <button type="submit" className="submit-button" id='submit-button' onClick={handleSubmit}>Submit</button> */}
        <button type="button" className="submit-button" id='submit-button' onClick={handleSubmit}>Submit</button>

        {isPopupVisible && <SubmitPopup onClose={closePopupSubmit} />}

      </form>
      
    </div>
  );
}

export default FormPage;
